import { useState } from 'react';

/**
 * Custom hook for validating input based on a character limit.
 * 
 * @param {number} maxLength The maximum allowed length for the input field.
 * @returns {Object} An object containing the error state, helper text, and the validation function.
 */
const useInputValidation = (maxLength = 100) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  /**
   * Validate the input value based on the max length.
   * 
   * @param {string} value The value to validate.
   * @returns {boolean} Whether the input is valid or not.
   */
  const validateInput = (value) => {
    if (value.length > maxLength) {
      setError(true);
      setHelperText(`Input cannot exceed ${maxLength} characters`);
      return false;
    } else {
      setError(false);
      setHelperText('');
      return true;
    }
  };

  return { error, helperText, validateInput };
};

export default useInputValidation;
